export { LoginPage } from "./LoginPage";
export { DashoardPage } from "./DashoardPage";
export { ConfigurationPage } from "./configurations/ConfigurationPage";
export { NewConfigurationPage } from "./configurations/NewConfigurationPage";
export { DetailConfigurationPage } from "./configurations/DetailConfigurationPage";
export { SecurityConfigurationPage } from "./configurations/SecurityConfigurationPage";
export { InitialBankConfigurationPage } from "./configurations/InitialBankConfigurationPage";
export { MappedFieldPage } from "./mappedfields/MappedFieldsPage";
export { NewMappedFieldPage } from "./mappedfields/NewMappedFieldPage";
export { DetailMappedFieldPage } from "./mappedfields/DetailMappedFieldPage";
export { AdminProductPage } from "./products/AdminProductPage";
export { ProductConfigurationPage } from "./products/ProductConfigurationPage";
export { AdminTransactionPage } from "./transactions/AdminTransactionPage";
export { TransactionConfigurationPage } from "./transactions/TransactionConfigurationPage";
export { AdminTranslationPage } from "./translations/AdminTranslationPage";
export { NewTranslationPage } from "./translations/NewTranslationPage";
export { AdminQuicklinksPage } from "./quicklinks/AdminQuicklinksPage";
export { IuviMarketingAdminPage } from "./iuvimarketing/IuviMarketingAdminPage";
export { AdminWidgetsPage } from "./widgets/AdminWidgetsPage";
export { AdminAgentsPage } from "./agents/AdminAgentsPage";
export { NewAgentPage } from "./agents/NewAgentPage";
export { AdminTenantsPage } from "./tenants/AdminTenantsPage";
export { TenantConfigurationPage } from "./tenants/TenantConfigurationPage";
export { AdminApplicationsPage } from "./applications/AdminApplicationsPage";
export { ApplicationsConfigurationPage } from "./applications/ApplicationsConfigurationPage";
export { EnvExportPage } from "./environments/EnvExportPage";
export { EnvImportPage } from "./environments/EnvImportPage";
export { AdminVersionPage } from "./versions/AdminVersionPage";
export { AdminUsersPage } from "./users/AdminUsersPage";
export { DetailUserPage } from "./users/DetailUserPage";
export { NewUserPage } from "./users/NewUserPage";
export { AdminConsoleTranslationPage } from "./consoletranslations/AdminConsoleTranslationPage";
export { AdminPointsPage } from "./points/AdminPointsPage";
export { DetailPointsPage } from "./points/DetailPointsPage";
export { NewServicePointsPage } from "./points/NewServicePointsPage";
export { NewMasterPointsPage } from "./points/NewMasterPointsPage";
export { NewPointOfAttentionPage } from "./points/NewPointOfAttentionPage";
export { AdminCataloguePage } from "./catalogue/AdminCataloguePage";
export { NewProtocolsPage } from "./catalogue/NewProtocolsPage";
export { AdminRolesPage } from "./roles/AdminRolesPage";
export { NewRolesPage } from "./roles/NewRolesPage";
export { ImportPage } from "./translations/ImportPage";
export { ErrorLabelsPage } from "./translations/ErrorLabelsPage";
export { ErrorEnvImportPage } from "./environments/ErrorEnvImportPage";
export { AuditoryReportPage } from "./auditory/AdminAuditoryPage";